<template>
  <div class="proof-container">
    <!-- Add files -->
    <v-card-text> Bitte Nachweis/Nachweise hochladen (PDF oder JPEG/PNG, maximal 10 MB je Datei). </v-card-text>

    <file-input
      show-size
      accept="application/pdf, .pdf, image/jpeg, image/png"
      label="Dateien einzeln auswählen oder hier ablegen"
      @change="onChange"
      :rules="rules"
      :loading="isLoading"
      :disabled="isLoading"
      :readonly="disabled"
      :maxFileSizeInMb="10"
      :onlyPdf="false"
      :multiple="true"
      :outlined="true"
    ></file-input>

    <v-chip class="mr-2 mb-2" v-for="(proof, idx) of fileProofs" :key="idx" @click="downloadFile(proof)">{{
      proof.originalName
    }}</v-chip>
  </div>
</template>

<script lang="ts">
import { customRule } from "@/lib/rules/customRule";
import { handleError } from "@/lib/utility/handleError";
import { ThgChargingStationProofDocumentDtoGen, ThgChargingStationProofDtoGen } from "@/services/thg/v1/data-contracts";
import { ThgModule } from "@/store/modules/thg.store";
import saveAs from "file-saver";
import { Component, Vue } from "vue-property-decorator";
import FileInput from "../utility/FileInput.vue";

export type ChargingStationFileProof = File /** timestamp to show when the document is uploaded */ & {
  uploaded: number;
};

@Component({
  components: {
    FileInput
  }
})
export default class ThgProof extends Vue {
  get thg() {
    return ThgModule.myThg;
  }

  get isLoading() {
    return ThgModule.isLoadingProofs;
  }

  file!: File | undefined;
  disabled = false;
  /**
   * is the file not uploaded yet
   */
  noDuplicateFiles = true;

  downloadFile(file: ThgChargingStationProofDocumentDtoGen) {
    saveAs(file.url, file.name);
  }

  get fileProofs() {
    return this.thg?.proofs || [];
  }

  get rules() {
    return [
      customRule(
        this.noDuplicateFiles,
        String(this.$i18n.t("components.thg.ThgChargingStationProof.fileAlreadyExists"))
      )
    ];
  }

  mount() {
    this.file = null as any;
  }

  async onChange(file: File) {
    if (!file) {
      return;
    }
    /** Don't allow uploading the same file twice */
    this.noDuplicateFiles = true;
    const dto: ThgChargingStationProofDtoGen = {
      file: file
    };

    try {
      if (this.thg?.id) {
        ThgModule.setProofLoading(true);
        let savedFile: ThgChargingStationProofDocumentDtoGen = null as any;
        savedFile = await ThgModule.uploadProof({ data: dto, thgId: this.thg.id });

        this.$emit("file-change", savedFile);
      }
    } catch (error) {
      handleError(error);
    } finally {
      ThgModule.setProofLoading(false);
    }
  }
}
</script>
<style scoped>
p {
  color: rgba(0, 0, 0, 0.6);
}
</style>
